// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"968":"e3a2534a","974":"1d2e4702"}[chunkId] + ".chunk.css";
};